import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import {
  useTheme, useMediaQuery, AppBar, Toolbar, Typography, Button, IconButton, Menu, MenuItem,
} from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import './NavBar.css';
import flag from '../assets/images/flag_test.png';

function NavBar({
  link1, link2, link3, link4,
}) {
  // Set transition style for smooth gradient change
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const styles = {
    appBar: {
      // background: 'linear-gradient(120deg, #D7F64D, #04C65D, #89DB33)',
      background: 'rgba(199, 227, 248, 1)',
      backgroundSize: '200% 100%',
      animation: '15s linear 0s infinite alternate none running gradient',
      transition: 'background 0.2s ease-in-out',
    },
  };

  return (
    <AppBar position="static" style={styles.appBar}>
      <Toolbar>
        {/* <Typography variant="h6">Dia</Typography> */}
        {isMobile && (
          <IconButton
            style={styles.menuButton}
            edge="start"
            color="inherit"
            aria-label="menu"
            onClick={handleMenuOpen}
          >
            <MenuIcon />
          </IconButton>
        )}
        <Typography variant="h6" component="a">
          <img src={flag} alt="flag" width="170px" loading="lazy" />
        </Typography>
        <div style={{ flexGrow: 1 }} />
        {!isMobile && (
          <>
            <NavLink
              to="/mop"
              style={{ textDecoration: 'none', color: 'rgba(40, 145, 200, 1)', marginRight: 20 }}
              activeStyle={{
                borderBottom: '2px solid rgba(40, 145, 200, 1)',
              }}
            >
              <Button color="inherit">{link1}</Button>
            </NavLink>
            <NavLink
              to="/mop/search"
              style={{ textDecoration: 'none', color: 'rgba(40, 145, 200, 1)', marginRight: 20 }}
              activeStyle={{
                borderBottom: '2px solid rgba(40, 145, 200, 1)',
              }}
            >
              <Button color="inherit">{link2}</Button>
            </NavLink>
            <NavLink
              to="/mop/lawbase"
              style={{ textDecoration: 'none', color: 'rgba(40, 145, 200, 1)', marginRight: 20 }}
              activeStyle={{
                borderBottom: '2px solid rgba(40, 145, 200, 1)',
              }}
            >
              <Button color="inherit">{link3}</Button>
            </NavLink>
            <NavLink
              to="/mop/contacts"
              style={{ textDecoration: 'none', color: 'rgba(40, 145, 200, 1)' }}
              activeStyle={{
                borderBottom: '2px solid rgba(40, 145, 200, 1)',
              }}
            >
              <Button color="inherit">{link4}</Button>
            </NavLink>
          </>
        )}
      </Toolbar>
      {isMobile && (
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
        >
          <MenuItem onClick={handleMenuClose}>
            <NavLink
              to="/mop"
              style={{ textDecoration: 'none', color: 'inherit' }}
              activeStyle={{
                fontWeight: 'bold',
              }}
            >
              {link1}
            </NavLink>
          </MenuItem>
          <MenuItem onClick={handleMenuClose}>
            <NavLink
              to="/mop/search"
              style={{ textDecoration: 'none', color: 'inherit' }}
              activeStyle={{
                fontWeight: 'bold',
              }}
            >
              {link2}
            </NavLink>
          </MenuItem>
          <MenuItem onClick={handleMenuClose}>
            <NavLink
              to="/mop/lawbase"
              style={{ textDecoration: 'none', color: 'inherit' }}
              activeStyle={{
                fontWeight: 'bold',
              }}
            >
              {link3}
            </NavLink>
          </MenuItem>
          <MenuItem onClick={handleMenuClose}>
            <NavLink
              to="/mop/contacts"
              style={{ textDecoration: 'none', color: 'inherit' }}
              activeStyle={{
                fontWeight: 'bold',
              }}
            >
              {link4}
            </NavLink>
          </MenuItem>
        </Menu>
      )}
    </AppBar>
  );
}
NavBar.propTypes = {
  link1: PropTypes.string,
  link2: PropTypes.string,
  link3: PropTypes.string,
  link4: PropTypes.string,
};

NavBar.defaultProps = {
  link1: 'головна',
  link2: 'пошук закладу',
  link3: 'законодавство',
  link4: 'контакти',
};
export default NavBar;
